export interface GalleryItem {
  image: string;
  title: string;
  tag: string;
  text: string;
}

export const galleryItems: GalleryItem[] = [
  {
    image: 'https://cdn.magicpatterns.com/uploads/ou1WPKZKuoTjQDGYvNDc2k/01-clase-lista-primaria.webp',
    title: 'Una clase completa, paso a paso',
    tag: '1º Primaria · Sesión 01A',
    text: 'Objetivo, material, distribución del grupo y tiempos en una misma página.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/jrDScG4zpWFEPYDxguMoxL/02-juego-pase-y-corte.webp',
    title: 'Del ejercicio al juego',
    tag: '5º Primaria · Sesión 07A',
    text: 'Practicar el pase y el corte, y aplicarlos en un juego de 3 contra 3.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/jiQ9vr8YUU6uxhdwG2wJcJ/03-variante-adaptaciones-rubrica.webp',
    title: 'La misma sesión, con ajustes y rúbrica',
    tag: '5º Primaria · Sesión 07B',
    text: 'Variante desarrollada, ajustes para 20 o 30 alumnos y criterios para observar.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/9VTpUWQ6H9FfsZsosU9niw/04-tactica-secundaria.webp',
    title: 'Decisiones tácticas en Secundaria',
    tag: '3º ESO · Sesión 09A',
    text: 'Recuperar el balón, ofrecer apoyo y decidir entre avanzar o conservar.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/pHCVa5ZyVfEuGbYYCq8SDd/05-kit-visual-orientacion.webp',
    title: 'Una ficha visual para reforzar',
    tag: 'Bono 2 · Ficha visual de 10 minutos',
    text: 'Orientación con montaje, variante y qué observar.'
  },
  {
    image: 'https://cdn.magicpatterns.com/uploads/3T5ZNdPi9HjVPjfUEHuRHG/06-registro-observacion-imprimible.webp',
    title: 'Evaluación lista para registrar',
    tag: 'Soporte imprimible',
    text: 'Plantilla imprimible para 30 alumnos: indicadores, nivel observado y espacio para evidencias y ajustes.'
  }
];
